











































































































import Vue, { PropType } from 'vue'
import { TopUpAgent } from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import { VueForm } from '@/utils/interfaces'
import SimpleTransferCard from './SimpleTransferCard.vue'
import Dialog from '@/components/Dialog.vue'

export default Vue.extend({
  components: {
    appSimpleTransferCard: SimpleTransferCard,
    appDialog: Dialog,
  },
  props: {
    from: Object as PropType<TopUpAgent>,
    to: Object as PropType<TopUpAgent>,
    field: String,
    action: Function as PropType<
      (method: string, value: number, description?: string) => Promise<boolean>
    >,
  },
  data() {
    return {
      rules: {
        lowerThan: (value: number) =>
          value <= ((this.from as { [key: string]: any })[this.field] || 0) ||
          this.$t('validation.must-be-lower-than-equal', {
            value: (this.from as { [key: string]: any })[this.field],
          }),
        greaterThan: (value: number) =>
          value >= 0 ||
          this.$t('validation.must-be-greater-than-equal', {
            value: 0,
          }),
        number: (value: string) =>
          number(value) || this.$t('validation.must-be-a-number'),
      },
      credit: 0,
      loading: false,
      description: '',
      descriptionDialog: false,
    }
  },
  computed: {
    disabledReceive(): boolean {
      if (
        this.field === 'topup_credit' &&
        (!this.to.topup_credit || Number(this.to.topup_credit) < this.credit)
      ) {
        return true
      } else if (!this.credit) {
        return true
      }
      return false
    },
    disabledSend(): boolean {
      if (
        this.field === 'topup_credit' &&
        (!this.from.topup_credit ||
          Number(this.from.topup_credit) < this.credit)
      ) {
        return true
      } else if (!this.credit) {
        return true
      }
      return false
    },
  },
  methods: {
    async onTransfer(method: string) {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const response = await this.action(
          method,
          this.credit,
          this.description,
        )
        if (response) {
          this.$emit('input', false)
          form.reset()
        }
      } finally {
        this.loading = false
      }
    },
  },
})
